import ProtectedRoute from 'components/ProtectedRoute'
import useFlag from 'hooks/useFlag'
import React from 'react'
import { Redirect, Switch } from 'react-router-dom'
import OperationsCenterDeliveryLocationSettings from 'scenes/OperationsCenter/DeliveryLocationSettings'

// `/delivery_location_settings` is the canonical route for the
// consolidated Delivery & Location Settings surface (DATA-4953).
// Gated behind `operations-center` so non-migrated merchants are
// redirected home. `ProtectedRoute` resolves the RBAC verb itself
// (access under RBAC, manage in legacy mode) — leaving `accessType`
// off keeps this in sync with the nav check.
const DeliveryLocationSettings = () => {
  const operationsCenterEnabled = useFlag('operations-center', false)

  if (!operationsCenterEnabled) {
    return <Redirect to="/" />
  }

  return (
    <Switch>
      <ProtectedRoute
        redirect="/"
        resource="OrderingManagement"
        exact
        path="/delivery_location_settings"
        component={OperationsCenterDeliveryLocationSettings}
      />
    </Switch>
  )
}

export default DeliveryLocationSettings
